import axiosInstance from "../api/index";
import { GET_CITY, GET_COMMISSION, GET_COUNTRY } from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const GetCity = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`city?status=1`);
    if (response?.data?.status) {
      dispatch({ type: GET_CITY, cityList: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
export const GetCountry = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`country`);
    if (response?.data?.status) {
      dispatch({ type: GET_COUNTRY, countrylist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getCommission = (type_url = 'publish_project') => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`commission?page=${type_url}`);
    if (response?.data?.status) {
      dispatch({ type: GET_COMMISSION, commissiondetails: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
